module.exports = __webpack_public_path__ + "files/03b849211be94265bc7cc2c322e1156c.svg";